import * as React from 'react'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {IInputData, IReadValidationData, IReadValidationSuccessData} from '../../interfaces/reducers/IRegImport'

interface OwnProps {
  readValidationData: IReadValidationData
}

interface ParentProps {}

interface DispatchProps {}

type Props = DispatchProps & ParentProps & OwnProps

const RegImportReadValidationsClass = (props: Props) => {
  const getSuccessData = (successData: IReadValidationSuccessData) => {
    return (
      <div className="import-params-success">
        <div>Успешно прочитане на данните</div>
        <br></br>
        <div>{`Брой затворени квартали: ${successData.QuarterNumbers}`}</div>
        <a href={successData.QuartersUrl} target="_blank" rel="noreferrer">
          DXF файл с данни за затворени квартали
        </a>
        <a href={successData.QuarterSegmentsUrl} target="_blank" rel="noreferrer">
          DXF файл с данни за използваните линии
        </a>
        <br></br>
        <div>{`Брой затворени парцели: ${successData.ParcelsNumber}`}</div>
        <a href={successData.ParcelsUrl} target="_blank" rel="noreferrer">
          DXF файл с данни за затворени парцели
        </a>
        <a href={successData.ParcelSegmentsUrl} target="_blank" rel="noreferrer">
          DXF файл с данни за използваните линии
        </a>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.readValidationData.loading) {
      if (props.readValidationData.successData) {
        return getSuccessData(props.readValidationData.successData)
      }
      return <div className="import-loading">В процес на четене на данните...(може да отнеме до 15 минути)</div>
    } else {
      if (props.readValidationData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.readValidationData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            <div>Грешки при четене на данните:</div>
            {errors}
          </div>
        )
      } else if (props.readValidationData.successData) {
        return getSuccessData(props.readValidationData.successData)
      }
    }
  }
  if (!props.readValidationData.exists) {
    return <div></div>
  }
  return <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>{getValidationStatusUI()}</div>
}

const mapStoreToProps = (store: IAppStore) => ({
  readValidationData: store.regImport.readValidationData
})

export const RegImportReadValidations = connect<OwnProps, DispatchProps, ParentProps>(
  mapStoreToProps,
  {}
)(RegImportReadValidationsClass)
